var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 54,
    viewBox: "0 0 56 54",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7246 35.7637L15.8281 7.83691L33.7556 29.9029L12.7246 35.7637Z",
    fill: "url(#paint0_linear_8_29)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8279 14.5713L27.5975 1.72935C27.443 1.26028 26.7743 1.2754 26.6411 1.75099L21.1543 21.3481",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9598 19.742L3.44302 20.0709C2.94929 20.083 2.77006 20.7274 3.18668 20.9926L20.3541 31.921",
    stroke: "black",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2547 35.4446L11.6055 48.141C11.4357 48.6047 11.9696 49.0077 12.369 48.7173L28.8302 36.7515",
    stroke: "black",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2645 39.9412L41.6669 48.5784C42.0469 48.8939 42.6055 48.5261 42.4659 48.0524L36.7123 28.5319",
    stroke: "black",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6304 28.8055L52.5945 20.8935C52.995 20.6045 52.7786 19.9716 52.285 19.9884L31.9459 20.6776",
    stroke: "black",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_29",
    x1: 23.2401,
    y1: 7.83691,
    x2: 23.2401,
    y2: 35.7637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.26d547e066bfeffc27d221337d6e6b65.svg";
export { ForwardRef as ReactComponent };